import React, { Dispatch } from 'react';
import { createContext, useContext, useContextSelector } from 'use-context-selector';
import { IActions } from './FastEntry.actions';
import reducer, { IState } from './FastEntry.reducer';
import { InitialState as  initialState } from './FastEntry.constants';

export const FastEntryStateContext = createContext<IState>(initialState);
export const FastEntryDispatchContext = createContext<Dispatch<IActions>>(() => null);

export const useFastEntryDispatch = () => useContext(FastEntryDispatchContext);
export const useFastEntryState = () => useContext(FastEntryStateContext);
export const useFastEntryContextSelector = <K extends keyof IState>(selector: (state: IState) => IState[K]) => useContextSelector<IState, IState[K]>(FastEntryStateContext, selector);

interface IFastEntryStateProvider {
  children: React.ReactNode;
}

const FastEntryStateProvider = ({ children }: IFastEntryStateProvider) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <FastEntryStateContext.Provider value={state}>
      <FastEntryDispatchContext.Provider value={dispatch}>
        {children}
      </FastEntryDispatchContext.Provider>
    </FastEntryStateContext.Provider>
  );
};

export default FastEntryStateProvider;
